export default function RealChatAnalysis() {
  const channels = [
    { icon: 'ri-telegram-line', name: 'Telegram' },
    { icon: 'ri-whatsapp-line', name: 'WhatsApp' },
    { icon: 'ri-computer-line', name: 'Bitrix24 / AmoCRM' },
    { icon: 'ri-message-3-line', name: 'CRM-чаты' },
    { icon: 'ri-facebook-line', name: 'Facebook Messenger' },
    { icon: 'ri-instagram-line', name: 'Instagram Direct' },
    { icon: 'ri-chat-3-line', name: 'Онлайн-чаты сайта' },
    { icon: 'ri-mail-line', name: 'E-mail' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-file-search-line"></i>
            Основа методологии
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Разбор реальных переписок компании
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Это то, что отличает наше обучение от шаблонных тренингов. Мы не разбираем абстрактные примеры — мы работаем с вашими реальными диалогами.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
              <i className="ri-search-eye-line text-teal-600"></i>
              До обучения — анализ по всем каналам
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
              {channels.map((item, i) => (
                <div key={i} className="bg-white rounded-xl p-4 border border-gray-100 text-center hover:border-teal-100 transition-colors group">
                  <div className="w-10 h-10 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0 mx-auto mb-2 group-hover:bg-teal-600/15 transition-colors">
                    <i className={`${item.icon} text-teal-600 text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">{item.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-teal-600/5 rounded-xl p-6 border border-teal-100 text-center">
              <div className="w-14 h-14 bg-teal-600/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-search-line text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-base font-semibold text-gray-900 mb-2">Анализируем реальные диалоги</h4>
              <p className="text-sm text-gray-600 leading-relaxed">Изучаем переписки с реальными клиентами: что работает, где теряются сделки, какие ошибки повторяются.</p>
            </div>
            <div className="bg-teal-600/5 rounded-xl p-6 border border-teal-100 text-center">
              <div className="w-14 h-14 bg-teal-600/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-chat-check-line text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-base font-semibold text-gray-900 mb-2">Разбираем на тренинге</h4>
              <p className="text-sm text-gray-600 leading-relaxed">Участники видят свои ошибки на конкретных примерах и сразу отрабатывают новые техники на своих же диалогах.</p>
            </div>
            <div className="bg-teal-600/5 rounded-xl p-6 border border-teal-100 text-center">
              <div className="w-14 h-14 bg-teal-600/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-voice-line text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-base font-semibold text-gray-900 mb-2">Сопровождаем после</h4>
              <p className="text-sm text-gray-600 leading-relaxed">Продолжаем разбирать новые переписки, даём обратную связь и корректируем стратегию.</p>
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mt-12 bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-10 text-center">
          <p className="text-lg md:text-xl text-white leading-relaxed font-medium">
            Это одна из сильнейших сторон программы. Участники не слушают теорию — они видят свои реальные зоны роста и получают конкретные инструменты, применимые завтра в работе.
          </p>
        </div>
      </div>
    </section>
  );
}